"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serialization = exports.AdminClient = exports.AdminServer = void 0;
class AdminServer {
    constructor() {
        throw new Error("AdminServer cannot be used within a browser");
    }
}
exports.AdminServer = AdminServer;
var admin_client_1 = require("../client/admin-client");
Object.defineProperty(exports, "AdminClient", { enumerable: true, get: function () { return admin_client_1.AdminClient; } });
exports.Serialization = require("../serialization/serialization");
//# sourceMappingURL=pluggable-admin.browser.js.map